import { ExpandMore } from '@mui/icons-material';
import { Accordion as MuiAccordion, AccordionDetails as MuiAccordionDetails, AccordionSummary as MuiAccordionSummary, Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FC } from 'react';

interface IAccordion {
  title: string | JSX.Element;
  showShading?: boolean;
  isExpanded?: boolean;
  onChange?: (event: React.SyntheticEvent, expanded: boolean) => void;
}

export const Accordion: FC<IAccordion> = ({ children, title, showShading = true, isExpanded, onChange }) => {
  const classes = useStyles({ showShading });

  return (
    <MuiAccordion className={classes.root} expanded={isExpanded} onChange={onChange}>
      <MuiAccordionSummary className={classes.accordion} expandIcon={<ExpandMore />} aria-controls="accordion-content" id="accordion-header">
        <div className={classes.topPanelSummaryWrapper}>
          <Typography>{title}</Typography>
        </div>
      </MuiAccordionSummary>
      <MuiAccordionDetails className={classes.details}>{children}</MuiAccordionDetails>
    </MuiAccordion>
  );
};

const useStyles = makeStyles<Theme, { showShading: boolean }>((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    '@media (min-width: 600px)': {
      flexDirection: 'row',
      alignItems: 'center'
    },
    '&:first-child': {
      marginTop: 0
    }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(0.5),
    backgroundColor: ({ showShading }) => (showShading ? theme.palette.grey[50] : undefined),
    borderTop: ({ showShading }) => (showShading ? undefined : `1px solid ${theme.palette.grey[300]}`),
    width: '100%'
  }
}));
